import { useLayoutEffect, useRef, useState } from "react";

export function useIsOverflowing<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const check = () => setIsOverflowing(el.scrollWidth > el.clientWidth);

    check();

    const resizeObserver = new ResizeObserver(check);
    resizeObserver.observe(el);

    return () => resizeObserver.disconnect();
  }, []);

  return { ref, isOverflowing };
}
